import styled, { css } from 'styled-components'
import { Button, contentColorStyle } from './button'

export type SecondaryButtonType = 'default' | 'negative'

const typeStyles = {
    default: css`
        ${(p) => contentColorStyle(p.theme.colors.primary.default)}

        &:hover {
            ${(p) => contentColorStyle(p.theme.colors.primary.green700)}
        }

        &:active {
            ${(p) => contentColorStyle(p.theme.colors.primary.green900)}
        }
    }
    `,
    negative: css`
        border: 1px solid ${(p) => p.theme.colors.primaryRed};
        ${(p) => contentColorStyle(p.theme.colors.primaryRed)}

        &:hover {
            border: 1px solid ${(p) => p.theme.colors.primaryRed};
            ${(p) => contentColorStyle(p.theme.colors.primaryRed)}
        }

        &:active {
            border: 1px solid ${(p) => p.theme.colors.primaryRed};
            ${(p) => contentColorStyle(p.theme.colors.primaryRed)}
        }
    `,
}

export const SecondaryButton = styled(Button)<{ $type?: SecondaryButtonType }>`
    background-color: ${(p) => p.theme.colors.white};

    ${(props) => typeStyles[props.$type ?? 'default']}
`
